<template>
  <select :value="value"
          :name="name"
          class="form-select select"
          :class="additionalSelectClasses"
          @change="$emit('input', $event.target.value)">
    <slot />
  </select>
</template>

<script>
export default {
  props: {
    additionalSelectClasses: {
      type: String,
      required: false
    },
    value: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },

  emits: ['input']
}
</script>

<style lang="scss" scoped>
select {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
